export enum EScreen {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

export enum ECommunicationMedium {
  WHATSAPP = 'WHATSAPP',
  PHONE = 'PHONE',
}

export enum EMemberGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum EPolicyStatus {
  NOT_BOUGHT = "NOT_BOUGHT",
  NOT_PAID = "NOT_PAID",
  COMPANY_CANCELLED = "COMPANY_CANCELLED",
  CUSTOMER_CANCELLED = "CUSTOMER_CANCELLED",
  REJECTED = "REJECTED",
  POLICY_GENERATED = "POLICY_GENERATED",
  PROCESSING = "PROCESSING",
}

export enum ERHIWebhookButton {
  HOME_CALL = 'home_call',
  HOME_WHATSAPP = 'home_whatsapp',
  BOOK_CALL_GENERIC = 'book_call_generic',
  BOOK_CALL = 'book_call',
  GET_PLAN = 'get_plan',
}

export enum EPatientRelationship {
  SELF = 'self',
  SPOUSE = 'spouse',
  KID = 'kid',
  PARENT = 'parent',
  SIBLING = 'sibling',
  PARENT_IN_LAW = 'parentInLaw',
  PARENT_IN_LAW_OTHER = 'parent-in-law',
}
export type TGender = 'MALE' | 'FEMALE';

export type TDateObject = {
  year: number | null;
  month: number | null;
  day: number | null;
};

export enum EnumDependentCreationSource {
  HR_DASHBOARD = 'HR_DASHBOARD',
  EMPLOYEE_APP = 'EMPLOYEE_APP',
}

export type TAppdate = {
  date: number;
  month: string;
  monthNumber: number;
  year: number;
};

export type TMemberWithDependent = {
  email: string;
  firstName: string;
  lastName: string;
  organisationId: string;
  phoneNumber: string;
  withoutMembership: boolean;
  removed: boolean;
  admin: boolean;
  super: boolean;
  inviteId: string;
  eid: string;
  isOTPverified: boolean;
  vip: boolean;
  gender: string;
  createdAt: string;
  inviteCreatedAt: string;
  benefitChoiceId: string;
  ctc: unknown; // Consider defining a specific type if possible
  profilePicture: unknown; // Consider defining a specific type if possible
  whatsappOptIn: string;
  enrollmentStatus: string;
  dateOfBirth: TAppdate;
  dateOfJoining: TAppdate;
  dependents: {
    createdAt: string;
    email: string;
    firstName: string;
    lastName: string;
    gender: string;
    relationship: string;
    organisationId: string;
    dateOfBirth: TAppdate;
    dobStr: string;
    id: string;
    endorsementStatus: EndorsementMemberStatusEnum; //optional based on query params
    source: EnumDependentCreationSource;
    createdBy: string;
  }[];
  id: string;
};

export enum EMemberRelationship {
  EMPLOYEE = 'EMPLOYEE',
  SPOUSE = 'SPOUSE',
  CHILD = 'CHILD',
  PARENT = 'PARENT',
  PARENT_IN_LAW = 'PARENT-IN-LAW',
  SIBLING = 'SIBLING',
  KID = 'KID',
  PARTNER = 'PARTNER',
  MISSING = 'MISSING',
  SELF = 'SELF',
  SON = 'SON',
  FATHER = 'FATHER',
  DAUGHTER = 'DAUGHTER',
  MOTHER = 'MOTHER',
}

export enum EAddMemberRelationship {
  Wife = 'Wife',
  Husband = 'Husband',
  Son = 'Son',
  Daughter = 'Daughter',
  SPOUSE = 'SPOUSE',
  KID = 'KID',
  CHILD = 'CHILD',
  Spouse = 'Spouse',
  Father = 'Father',
  Mother = 'Mother',
  Sibling = 'Sibling',
  Parent = 'Parent',
}

export enum EndorsementMemberStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Failed = 'Failed',
  Skipped = 'Skipped',
  Ignored = 'Ignored',
}

export type IHospital = {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  distance?: number;
  phone: Array<string>;
  location: {
    type: 'Point';
    coordinates: [number, number];
  };
  website: string;
  email: string;
  googleMaps: {
    placeId: string;
    url: string;
    cid: string;
  };
};
import {
  MutationFunction,
  MutationKey,
  QueryFunction,
  QueryKey,
} from '@tanstack/react-query';

export type IQuery<T> = {
  queryKey: QueryKey;
  queryFn: QueryFunction<T>;
  cacheTime?: number;
  staleTime?: number;
};

export type IMutationQuery<T> = {
  mutationKey: MutationKey;
  mutationFn: MutationFunction<T>;
};

export interface IClaimsListQuery {
  claimsList: {
    /**
     * page number
     */
    page: number;
    pageSize: number;
    /**
     * list of claims
     */
    results: Array<IClaimDetails>;
    /**
     * total claims
     */
    size: number;
    _links?: {
      next: string | null;
      prev: string | null;
      self: string | null;
    };
  };
}

export interface IAllClaimsListQuery {
  claimsList: {
    activeClaims: IClaimsListQuery | [];
    draftClaims: IClaimsListQuery | [];
    pastClaims: IClaimsListQuery | [];
  };
}

export interface IClaimDetailsQuery {
  claimDetails: IClaimDetails;
}

export enum EClaimCreationStatus {
  ACTIVE = 'active',
  DRAFTS = 'drafts',
  PAST = 'past',
}

export interface IBenefitFeatureItem {
  key: string;
  description: string;
  title: string;
}

export interface IBenefitFeatures {
  url: string;
  includes: Array<IBenefitFeatureItem>;
  excludes: Array<IBenefitFeatureItem>;
}

export interface IBenefit {
  planVariant: 'saver' | 'standard' | 'premium';
  orgBenefitId: string;
  plan: IPlan;
  membership: IMembership;
  coverageType: 'e' | 'esc' | 'escp';
  benefitId: string;
  planVariantBasedChoice: string;
  features?: IBenefitFeatures;
}

export interface IMemberBenefit {
  benefitGrade: string | null;
  benefitLabel: string;
  benefitLogo: string;
  benefitProviderHandle: string;
  benefitProviderLogo: string;
  benefitProviderName: string;
  benefitType: string;
  category: string;
  expirationDate: string;
  id: string;
  inceptionDate: string;
  organisationBenefitLabel: string | null;
  planDetails: {
    sumInsured: {
      value: number;
    };
    covers: {
      value?: string;
    };
  };
  planId: string;
  policyNumber: string;
  riders: Array<unknown>;
  tpaName: string;
}

export interface IPlan {
  provider: {
    handle: string;
    name: string;
  };
  type: string;
  category: string;
  tpaName: string;
  label: string;
  faq: {
    description: Array<{
      uiorder: number;
      answer: string;
      question: string;
    }>;
    url: null;
  };
  redeemConfig: null;
  costType: string;
  networkHospitals: {
    url: string;
  };
  blacklistedHospitals: {
    url: string;
  };
  faqs: Array<{
    uiorder: number;
    answer: string;
    question: string;
  }>;
  costTypeLabel: string;
}

export interface IMembership {
  id: string;
  status: string;
  details: {
    inceptionDate: string;
    expirationDate: string;
    policyNumber: string;
    sumInsured: string;
  };
  attributes: Array<{
    label: string;
    key: string;
    value: string;
  }>;
}

export interface ITreatmentStage {
  formSchemaField: 'start_date' | 'end_date';
  slug: string;
  subtitle: string;
  title: string;
  tentativeDaysOptionList: Array<{ text: string; value: number }>;
}

export enum ECareType {
  IPD = 'IPD',
  PRE_POST = 'PrePost',
  DAY_CARE = 'DayCare',
  OPD = 'OPD',
}

export interface IFormSchema {
  start_date: {
    text: string;
    field: string;
    type: string;
    lower_limit: string;
    upper_limit: string;
    helper_text?: string;
  };
  end_date: {
    text: string;
    field: string;
    type: string;
    lower_limit: string;
    upper_limit: string;
    helper_text?: string;
  };
}

export interface IFeatureCategory {
  benefits: Array<string>;
  text: string;
  subtext: string;
  typeOfCare: ECareType;
  treatmentStageOptionList: Array<ITreatmentStage>;
  formSchema: {
    start_date: {
      text: string;
      field: string;
      type: string;
      lower_limit: string;
      upper_limit: string;
      helper_text?: string;
    };
    end_date: {
      text: string;
      field: string;
      type: string;
      lower_limit: string;
      upper_limit: string;
      helper_text?: string;
    };
  };
}

export interface IMember {
  dob: string;
  memberId: string;
  lastName: string;
  firstName: string;
  gender: 'male' | 'female';
  admin: boolean;
  dependents?: Array<IDependent>;
  eid: string;
  email: string;
  organisationId: string;
  organisationName: string;
  phoneNumber: string;
  relationship: EPatientRelationship;
  name: string;
  benefits: Array<IBenefit>;
  featureCategories: Record<string, IFeatureCategory>;
  dependentId?: string | null;
}

export interface IFormSchema {
  start_date: {
    text: string;
    field: string;
    type: string;
    lower_limit: string;
    upper_limit: string;
    helper_text?: string;
  };
  end_date: {
    text: string;
    field: string;
    type: string;
    lower_limit: string;
    upper_limit: string;
    helper_text?: string;
  };
}

export interface IDependent {
  firstName: string;
  lastName: string;
  dob: string;
  gender: string;
  relationship: EPatientRelationship;
  dependentId: string;
  memberId: string;
  name: string;
  membership: Array<IBenefit>;
}

export interface IDigitisationFields {
  categoryId: string;
  label: string;
  maxTextLength: number;
  name: string;
  order: string;
  placeholder: string;
  title: string;
  type: string;
  value: string;
  variableName: string;
  regex?: string;
  hint?: string;
  confirmField?: string;
  capitalise?: string;
  maskCharacters?: string;
  sectionTag: string;
  fieldUrl?: string;
  disabled?: boolean;
}

export interface IPreviewDocs {
  thumbnailUrl: string;
  mediaUrl: string;
  mediaType: 'image' | 'video' | 'hyperlink' | null;
  autoplay: boolean;
  allowSkip: boolean;
}

export interface IInstruction {
  iconUrl: string;
  title: string;
  htmlText?: string;
  dontsIconUrl?: string;
  dosIconUrl?: string;
  dontsList?: Array<{ htmlText: string }>;
  dosList?: Array<{ htmlText: string }>;
  eventName?: string;
  previewDocs?: IPreviewDocs;
}

export type TCheckbox = {
  type: string;
  name: string;
  text: string;
  value: boolean;
  required: boolean;
  errorMessage: string;
};

export interface IUploadDirection {
  downloadText: string;
  downloadUrl: string;
  leaflet: {
    htmlText: string;
  };
  preFilled: boolean;
  sampleImage: string;
}

export interface IFAQ {
  questionHtml: string;
  answerHtml: string;
}

export interface ISectionForm {
  title: string;
  downloadButtonText: string;
  url: string;
}

export interface ICTA {
  type: string;
  text: string;
  deeplink: string;
  onClick?: string;
  disabled?: boolean;
  loading?: boolean;
}

export enum EDocumentVerificationStatus {
  IN_PROCESS = 'in-process',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  ERROR = 'error',
}

export interface IDocumentVerification {
  status: EDocumentVerificationStatus;
  errorMessage: string;
}

export interface IDocument {
  documentId: string;
  name: string;
  previewUrl: { '64': string; preview?: string };
  url: string;
  sectionTag: string;
  createdAt: string;
  attrs: Record<string, string | number>;
  verification?: IDocumentVerification;
  timeSinceUploadText?: string;
  preFilled?: boolean;
}

export function isIDocument(file: unknown): file is IDocument {
  if (
    typeof file === 'object' &&
    file !== null &&
    'documentId' in file &&
    'name' in file &&
    'previewUrl' in file &&
    'url' in file &&
    'sectionTag' in file &&
    'createdAt' in file &&
    'attrs' in file &&
    typeof (file as IDocument).documentId === 'string' &&
    typeof (file as IDocument).name === 'string' &&
    typeof (file as IDocument).previewUrl === 'object' &&
    typeof (file as IDocument).previewUrl['64'] === 'string' &&
    ((file as IDocument).previewUrl.preview === undefined ||
      typeof (file as IDocument).previewUrl.preview === 'string') &&
    typeof (file as IDocument).url === 'string' &&
    typeof (file as IDocument).sectionTag === 'string' &&
    typeof (file as IDocument).createdAt === 'string' &&
    typeof (file as IDocument).attrs === 'object' &&
    (file as IDocument).attrs !== null &&
    Object.values((file as IDocument).attrs).every(
      (attr) => typeof attr === 'string' || typeof attr === 'number',
    ) &&
    ((file as IDocument).verification === undefined ||
      (typeof (file as IDocument).verification === 'object' &&
        (file as IDocument).verification !== null &&
        Object.values(EDocumentVerificationStatus).includes(
          (file as IDocument)?.verification
            ?.status as EDocumentVerificationStatus,
        ) &&
        typeof (file as IDocument)?.verification?.errorMessage === 'string')) &&
    ((file as IDocument).timeSinceUploadText === undefined ||
      typeof (file as IDocument).timeSinceUploadText === 'string') &&
    ((file as IDocument).preFilled === undefined ||
      typeof (file as IDocument).preFilled === 'boolean')
  ) {
    return true;
  }

  return false;
}

export interface IPrefillBanner {
  documents?: Array<IDocument>;
  iconUrl: string;
  htmlText: string;
  CTA?: ICTA;
  state: 'pre-filled' | 'post-filled' | 'info';
}

export interface ISupportingDocumentSection {
  supportingDocType: string;
  title: string;
  buttonText: string;
  hint: string;
  attrs: Record<string, string | number>;
  required: boolean;
  maxFileSizeMB: number;
  allowedFileTypes: Array<string>;
  maxFileCount?: number;
  deleteOnPrimaryDocDeletion?: boolean;
}

export interface ISampleDocument {
  downloadButtonText: string;
  title: string;
  url: string;
}

export interface ISection {
  allowedFileTypes?: Array<string>;
  emailTitle?: string;
  hint?: string;
  maxFileSizeMB?: number;
  minFileSizeMB?: number;
  required: boolean;
  sampleDocuments: Array<ISampleDocument>;
  sectionTag: string;
  title: string;
  subtitle?: string;
  hasToBeVerified?: boolean;
  instructions?: IInstruction;
  iconUrl: string;
  order: number;
  forms: Array<ISectionForm>;
  upload: {
    hint: string;
    buttonText: string;
    allowedFileTypes: Array<string>;
    maxFileSizeMB: number;
  };
  checkboxes: Array<TCheckbox>;
  skipSection: {
    type: string;
    name: string;
    title: string;
    subtitle: string;
    value: boolean;
  };
  faqs: Array<IFAQ>;
  digitisationInputTitle?: string;
  digitisationInputFields: Array<IDigitisationFields>;
  userUploadDirections?: IUploadDirection;
  preFillBanner?: IPrefillBanner;
  dependentPreFillBanner?: IPrefillBanner;
  supportingDocUploadOptionList?: Array<ISupportingDocumentSection>;
  stepInline?: boolean;
  documentsToUpload?: {
    title: string;
    documentsList: Array<string>;
  };
}

export interface ICategory {
  iconUrl: string;
  title: string;
  subtitle?: string;
  slug: string;
  order: number;
  instructions?: IInstruction;
  sections: Array<ISection>;
  checkboxes?: Array<TCheckbox>;
  inputFieldGroups?: Array<{
    editRedirectLink: string;
    editable: boolean;
    title: string;
    inputFields: Array<IDigitisationFields>;
  }>;
  signatureRequired?: boolean;
}

export interface IInputFieldGroup {
  editRedirectLink: string;
  editable: boolean;
  title: string;
  inputFields: Array<IDigitisationFields>;
  documentsBanner: IPrefillBanner;
  CTA: ICTA;
}

export interface IClaimAmountPrompt {
  title: string;
  inputFields: Array<IDigitisationFields>;
  walletBalance: {
    text: string;
    totalWalletBalance: number;
    availableWalletBalance: number;
  };
}

export enum EPaymentOption {
  MOBILE = 'MOBILE_NUMBER',
  VPA = 'VPA',
  BANK_DETAILS = 'BANK_ACCOUNT',
}

export interface IPaymentSelector {
  title: string;
  subtitle: string;
  availablePaymentOptions: Array<EPaymentOption>;
}

export interface IDetailsItem {
  iconUrl?: string;
  subtitle: string;
  title: string;
}

export interface IClaimDetailsForUI {
  detailsList: Array<IDetailsItem>;
  type: string;
}

export interface IDocumentsRequiredContent {
  slug: string;
  title: string;
  subtitle?: string;
  name: string;
  order: number;
  instructions?: IInstruction;
  categories: Array<ICategory>;
  checkboxes?: Array<TCheckbox>;
  inputFieldGroups?: Array<IInputFieldGroup>;
  signatureRequired?: boolean;
  claimAmountPrompt?: IClaimAmountPrompt;
  paymentSelector?: IPaymentSelector;
  claimDetailsForUI?: Array<IClaimDetailsForUI>;
  displayAsNonStep?: boolean;
}

export enum EClaimStages {
  // Cashless
  OPEN_LEAD = 'open-lead',
  QUALIFIED_LEAD = 'qualified-lead',
  SETTLED = 'settled',
  PRE_AUTH_REJECTED = 'pre-auth-rejected',
  FINAL_SETTLEMENT_REJECTED = 'final-settlement-rejected',
  PRE_AUTH_REJECTED_CLOSED = 'pre-auth-rejected-closed',
  FINAL_SETTLEMENT_REJECTED_CLOSED = 'final-settlement-rejected-closed',
  DISQUALIFIED_LEAD = 'disqualified-lead',
  // Reimbursement
  DOCUMENTS_REQUESTED = 'documents-requested',
  DOCUMENTS_SUBMITTED = 'documents-submitted',
}

export interface IStatusHighlight {
  background: string;
  linkText: string;
  redirectTo: string;
  subtitle: string;
  title: string;
}

export interface ICourierDetail {
  iconUrl: string;
  label: string;
  text: string;
}

export interface IStatusListItem {
  eventDate: string;
  flag: string;
  iconUrl: string;
  stage: string;
  subtitle: string;
  subtitle2: string;
  textColor: string;
  title: string;
  type: string;
}

export interface IArticleMeta {
  collectionName: string;
  id: string;
  coverImageUrl?: string;
  title: string;
  contentTypeDescription: string;
  contentTypeIconUrl: string;
  contentLengthDescriptionText: string;
  contentLengthFontColor: string;
  contentLengthBgColor: string;
}

export interface ICashlessTimelineItem {
  CTA: ICTA;
  completionTATTime: string;
  descriptionHTML: string;
  lateDescriptionHTML?: string;
  eventTime: string;
  stage: string | EClaimStages;
  stageType: 'red' | 'green';
  status: 'done' | 'pending';
  title: string;
  terminalStage?: boolean;
}

export interface ICashlessStatusContent {
  AIClaimBuddyPromptList: Array<{ text: string }>;
  callbackIssueList: Array<unknown>;
  thingsToKeepInMind: Array<IArticleMeta>;
  timeline: Array<ICashlessTimelineItem>;
  customerSupportNumber: string;
}

export interface IUiRepresentation {
  latestUpdate: {
    text: string;
    value: string;
  };
  status: {
    icon: {
      svg: string;
      png: string;
    };
    colorBackground: string;
    textColor: string;
    value: string;
    valueCaps?: string;
  };
}

export enum EClaimType {
  CASHLESS = 'Cashless',
  PLANNED = 'Planned',
  REIMBURSEMENT = 'Reimbursement',
}

export enum EBenefitCategory {
  INSURANCE = 'insurance',
  EXPENSE_MANAGEMENT = 'expense-management',
}

export interface IApplicableBenefit {
  orgBenefitId: string | null;
  tpaName: string | null;
  insuranceProviderPartner: string | null;
  insuranceProviderHandle: string | null;
  typeOfBenefit: string | null;
}

export interface IClaimPNRD {
  externalDateTime: string;
  externalReason: string;
  internalDateTime: string;
  internalReason: string;
  source?: 'existing' | 'new' | null;
}

export interface IClaimDetails {
  previouslyUploadedDocuments?: Array<{
    documents: Array<IDocument>;
    title: string;
    subtitle: string;
    uiorder: number;
  }>;
  stage: string | EClaimStages;
  dateOfAdmission: string;
  dateOfDischarge: string;
  patientName: string;
  patientGender: 'male' | 'female';
  createdAt: string;
  updatedAt: string;
  hospital: {
    hospitalname: string;
  };
  canDelete: boolean;
  typeOfCare: string;
  reasonForHospitalization: string;
  memberName: string;
  redirectTo: string;
  note: string;
  noteSourceText: string;
  documentsRequiredContentPreScript?: string;
  documents: Array<IDocument>;
  amount: number;
  selectedPaymentAccountDetailId?: string;
  uploadDocsCompletedPage?: number;
  documentsUpdateRequestedCounter?: number;
  queryRaisedCounter: number;
  reviewDetails?: {
    DURFeedback: Array<{ categoryNotes: Record<string, string> }>;
  };
  leadRejectionReasonType?: string;
  finalSettlementRejectionReasonType?: string;
  preAuthRejectionReasonType?: string;
  approvedLetterURL?: string;
  settlementLetterURL?: string;
  patientId: string;
  memberId: string;
  typeOfClaim: EClaimType;
  plumClaimId: string;
  patientRelationship: EPatientRelationship;
  expected?: Record<
    EClaimStages,
    {
      date: string;
    }
  >;
  statusContent?: {
    courierPendingContent: IStatusHighlight;
    contentVariables: {
      courierAddress: string;
    };
    statusPageContent: {
      courierDetails: Array<ICourierDetail>;
      highlight: IStatusHighlight;
      list: Array<IStatusListItem>;
    };
    cashlessStatusPageContent?: ICashlessStatusContent;
  };
  insuranceProviderHandle: string;
  tpaName?: string;
  typeOfBenefit?: 'health-expenses' | 'gmc';
  organisationBenefitId?: string;
  uiRepresentation: IUiRepresentation;
  reasonForConsulation: string;
  courierDetailPage?: {
    address: string;
    fields: Array<{
      type: string;
      label: string;
      placeholder: string;
      name: string;
    }>;
  };
  claimCourierPending: boolean;
  insurerClaimId: string;
  modeOfSubmission: string;
  isClosed: boolean;
  isClaimForDependent?: boolean;
  isClaimPreDigitised?: boolean;
  digitisationSuccessful: boolean;
  isClaimDigitised: boolean;
  nextAllowedStepSlug: string;
  digitisationInputFields?: Array<IDigitisationFields>;
  documentsUploadPageContent: Array<IDocumentsRequiredContent>;
  pnrd?: IClaimPNRD;
}

export type IRelationship =
  | 'self'
  | 'father'
  | 'mother'
  | 'spouse'
  | 'son'
  | 'daughter';

export type ITypeOfCare =
  | 'hospitalisation'
  | 'daycare'
  | 'domiciliary'
  | 'opd'
  | 'emergency';

export type ITypeOfClaim = 'cashless' | 'reimbursement';

export type IGender = 'male' | 'female';

export type ICashlessClaim = {
  plumClaimId: string;
  insurerClaimId: string;
  patientName: string;
  patientGender: IGender;
  patientRelationship: IRelationship;
  typeOfCare: ITypeOfCare;
  stage: string;
  dateOfAdmission: string;
  hospital: {
    hospitalname: string;
  };
  insuranceProviderHandle: string;
};

export type IImportedCashlessClaims = {
  status: 'inProgress' | 'completed' | 'failed';
  claimsDataSource: 'plum' | 'insurer' | null;
  results: Array<IClaimDetails>;
};
export type INetworkHospitalResponse = {
  total: number;
  next: number;
  list: IHospital[];
};

export interface INetworkHospitalConfig {
  enabled: boolean;
  message: string;
  blackListedHospitals?: string | null;
}

export enum EHospitalStatus {
  NETWORK = 'NETWORK',
  BLACKLISTED = 'BLACKLISTED',
  NON_NETWORK = 'NON_NETWORK',
}

export enum EMessageType {
  TOKEN = 'TOKEN',
  READY = 'READY',
  // CB = CLAIMS_BOT
  CB_CLAIM_DETAILS = 'CB_CLAIM_DETAILS',
  CB_INITIAL_PROMPT = 'CB_INITIAL_PROMPT',
  CB_CLEAR_CHAT = 'CB_CLEAR_CHAT',
  CLOSE_IFRAME = 'CLOSE_IFRAME',
  // NB = NativeBridge
  NB_CALLBACK = 'NB_CALLBACK',
  CLOSE_FPM_MODAL = 'CLOSE_FPM_MODAL',
  OPEN_ARTICLE = 'OPEN_ARTICLE',
}

export interface IMessagePayload {
  type: EMessageType;
  data: Array<EMessageType> | string | object | boolean;
}

export type IArticleMediaType =
  | 'image/webp'
  | 'image/png'
  | 'image/jpg'
  | 'image/jpeg'
  | 'video/mp4';

export type IArticleMedia = {
  data: Array<{
    id: string;
    attributes: {
      name: string;
      caption: string;
      width: string;
      height: string;
      url: string;
      size: number;
      previewUrl: string;
      mime: IArticleMediaType;
    };
  }>;
};

export type IArticleQuery = {
  data: {
    id: string;
    meta: unknown;
    attributes: {
      title: string;
      body1: string;
      body2?: string;
      body3?: string;
      media1: IArticleMedia;
      media2?: IArticleMedia;
      media3?: IArticleMedia;
      contentLengthDescription?: string;
    };
  };
};

export interface IPolicyGPTStatusQuery {
  orgId: string;
  status: boolean;
}

export interface IFeatureFlag {
  name: string;
  enabled: boolean;
}

export enum EEnrollmentStatus {
  null = 'null',
  INCOMPLETE = 'INCOMPLETE',
  ENROLLED = 'ENROLLED',
  COMPLETE = 'COMPLETE',
  UNSET = 'UNSET',
}

export interface IUserConfig {
  id: string;
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isPhoneVerified: boolean;
  organisation: {
    id: string;
    name: string;
  };
  enrollmentStatus: EEnrollmentStatus;
  gender: string;
  dateOfBirth: {
    date: number;
    month: string;
    monthNumber: number;
    year: number;
  };
  eid: string;
  featureFlags: Array<IFeatureFlag>;
  source: string;
  care: {
    planId: string;
    planType: string;
    active: boolean;
    benefitGrade: string;
  };
  admin: boolean;
  super: boolean;
  statusInternal?: string;
  defaultRoute: string;
  enrollmentUrl: string;
  inviteCreatedAt: string;
  personalEmail: string;
  isMidTermAdditionEnabled: boolean;
  cultPromoOpenTillTime?: number;
  showCultPromo?: boolean;
  status?: string;
}

export interface IAccountDetail {
  memberId: string;
  accountSwitcherOrganisationStatus?: string;
  currentLoggedIn: boolean;
  organizationName: string;
  accountValidTill: string;
  contextualInfo: string;
  isDependent: boolean;
  authCode: string;
  loginType: 'MEMBER' | 'IAM';
}

export interface IClaimsCount {
  active?: number;
  drafts?: number;
}

export interface IAvailableClaimType {
  title: string;
  subtitle: string;
  iconUrl: string;
  typeOfClaim: EClaimType;
  benefitCategory: EBenefitCategory;
}

export enum EUploadSectionTags {
  BANK_DETAILS_SECTION = 'bank-account-detail',
  PAN_CARD_SECTION = 'pan-card',
  PATIENT_ID_PROOF_SECTION = 'patient-id-proof',
  ID_PROOF_SECTION = 'id-proof',
}

export enum EUploadBankSectionChoices {
  CANCELLED_CHEQUE = 'Cancelled cheque',
  PASSBOOK = 'Passbook',
  BANK_STATEMENT = 'Bank statement',
}

export interface IRenderFormInputField {
  categoryId: string;
  label: string;
  maxTextLength: number;
  name: string;
  order: string;
  placeholder: string;
  title: string;
  type: 'amount' | 'text'; // Type can be constrained to specific options
  value: string;
  variableName: string;
  regex?: string;
  hint?: string;
  confirmField?: string;
  capitalise?: string;
  maskCharacters?: string;
  sectionTag: string;
  fieldUrl?: string;
  disabled?: boolean;
}

export type IRenderFormValues = Record<string, string | number | null>;

export interface ISignedUrl {
  documentId: string;
  url: string;
  error?: string;
}

export enum EBankValidationStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PROCESSING = 'PROCESSING',
}

export interface IBankAccount {
  accountId: string;
  vpa: string;
  type: EPaymentOption;
  status: EBankValidationStatus;
  nameWithBeneficiaryBank: string;
  maskedAccountNumber: string;
  ifscCode: string;
  bankName: string;
  bankLogo: string;
  verificationStatus?: {
    isVerified: boolean;
    reason: string;
  };
  error?: {
    code: string;
    message: string;
  };
}

export interface IBankValidationResponse {
  status: EBankValidationStatus;
  accountId: string;
  error?: {
    code: string;
    message: string;
  };
}

export interface ITokboxAppointmentType {
  curableAppointmentRef: {
    id: string;
    patientId: string;
    patientNo: string;
    familyMemberId: string;
  };
  patientDob: {
    date: number;
    monthNumber: number;
    year: number;
  };
  slot: {
    slotDateTime: string;
    sessionMinutes: number;
    endTime: string;
  };
  icalConfig: {
    doctor: {
      uniqueId: string;
      sequenceNo: number;
    };
    patient: {
      uniqueId: string;
      sequenceNo: number;
    };
  };
  allergies: [];
  consultantId: string;
  consultationRefNum: string;
  contactEmail: string;
  contactNumber: string;
  createdAt: string;
  d2cUserId: string;
  documents: [];
  isCallStarted: boolean;
  isDoctorJoined: boolean;
  isPatientJoined: boolean;
  isPrescriptionAvailable: boolean;
  isRescheduled: boolean;
  meta: {
    memberId: string;
    bookedByDependent: null;
  };
  patientGender: string;
  patientJoinLink: string;
  patientName: string;
  patientRelation: string;
  preferredLanguage: string;
  reasonForConsultation: string;
  rescheduleCount: number;
  residentState: string;
  speciality: string;
  state: EAppointmentState;
  updatedAt: string;
  conversationDuration: string;
  isCallViaPhone: boolean;
  id: string;
  status: EAppointmentStatus;
  isReconciliationRequired: boolean;
  consultant: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    title: string;
    imageUrl: string;
    experienceInYears: number;
    educationQualifications: string[];
    languages: string[];
    gender: string;
    specialities: string[];
    active: boolean;
    curableDoctorRef: {
      id: string;
    };
    treatments: [];
    bio: string;
    patientExperience: [];
    certification: string;
    startOfPracticeYear: string;
    educationQualificationsWithInstitute: [];
  };
  showJoinCallButton: boolean;
  showPrescriptionDownloadButton: boolean;
  prescriptionWillBeAvailableShortly: boolean;
  showBookAgainButton: boolean;
  showCancelButton: boolean;
  showRescheduleButton: boolean;
  showGiveFeedbackButton: boolean;
  statusBadge: string;
}

export interface ITokboxAppointmentDetails {
  appointments: ITokboxAppointmentType[];
  cursor: {
    page: number;
    limit: number;
    nextPage: number;
  };
}

export enum EVideoProviderType {
  VIDEOSDK = 'videosdk',
  TOKBOX = 'tokbox',
}

export interface ITokboxDetailsResponse {
  sessionId: string;
  apiKey: string;
  token: string;
  videoProviderType?: EVideoProviderType;
}

export interface ISubmitFeedbackTypes {
  appointmentId: string;
  comment: string;
  consultantRating: number;
  videoExpRating: number;
}

export interface ISubmitFeedbackResponseTypes {
  comment: string;
  consultantRating: number;
  videoExpRating: number;
}

export enum EAppointmentState {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}
export enum EAppointmentStatus {
  CANCELLED_BY_PATIENT = 'CANCELLED_BY_PATIENT',
  CANCELLED_BY_DOCTOR = 'CANCELLED_BY_DOCTOR',
  CALL_PENDING = 'CALL_PENDING',
  CALL_DONE_WAITING_PRESCRIPTION = 'CALL_DONE_WAITING_PRESCRIPTION',
  COMPLETED = 'COMPLETED',
  DOCTOR_NO_SHOW = 'DOCTOR_NO_SHOW',
  PATIENT_NO_SHOW = 'PATIENT_NO_SHOW',
  UNSUCCESSFUL_CALL = 'UNSUCCESSFUL_CALL',
  UNSUCCESSFUL_CALL_DUO_JOINED_AT_IRREGULAR_PERIOD = 'UNSUCCESSFUL_CALL_DUO_JOINED_AT_IRREGULAR_PERIOD',
  INVALID_STATUS_DUE_SYSTEM_ERROR = 'INVALID_STATUS_DUE_SYSTEM_ERROR',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  FAILED = 'APPOINTMENT_FAILED',
}

export interface ICityState {
  cityName: string;
  stateName: string;
  cityKey: string;
  stateKey: string;
}

export enum ECurrency {
  INR = 'INR',
}

export interface IMoney {
  centAmount: number;
  currency: ECurrency;
}

export interface IMoneyWithNativeString extends IMoney {
  currencyNativeString: string;
}

export interface IMoneyWithNativeStringWithoutDecimal
  extends IMoneyWithNativeString {
  currencyNativeStringWithoutDecimal: string;
}
export enum EPricingType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum EDiscountType {
  PERCENT = 'PERCENT',
  FIXED = 'FIXED',
}

export interface IPricing {
  /**
   * pricingId
   */
  id: string;
  active: boolean;
  skuId: string;
  stickerPrice: IMoney;
  price: IMoney;
  discount: IMoney;
  hsnCode: string;
  pricingType: EPricingType;
  pricingFetchUrl: string;
  cityState: ICityState;
  walletActive: boolean;
  walletEligible: boolean;
  walletRedeemableAmount: IMoneyWithNativeStringWithoutDecimal;
  taxComponents: Array<{
    key: string;
    centAmount: number;
    currency: ECurrency;
    rate: number;
  }>;
}

export enum EnumBenefitCostType {
  FREE = 'FREE',
  PAID = 'PAID',
}

export interface ISKU {
  costType?: EnumBenefitCostType;
  category: string;
  benefitId: string;
  title: string;
  homeSectionHeadline?: string;
  label: string;
  type: string;
  benefitType: string;
  features: {
    inclusions: Array<{
      key: string;
      value: string;
    }>;
    exclusions: Array<{
      key: string;
      value: string;
    }>;
  };
  provider?: {
    handle: string;
    name: string;
  };
  termsOfUse?: string;
  terms?: Array<{
    uiOrder: number;
    text: string;
  }>;
  redeemConfig?: {
    instructions: Array<{
      uiOrder: number;
      text: string;
    }>;
    redemptionText: string;
    redemptionUrl: string;
  };
  faq: {
    description: Array<{
      question: string;
      answer: string;
      uiOrder: number;
    }>;
  };
  totalSavings?: number;
  termsAndConditions?: Array<{
    key: string;
    value: string;
  }>;
  pricing: Array<IPricing>;
  sku?: string;
  redirectionUrl?: string;
  fulfillmentStrategy?: string;
  testimonials?: Array<{
    title?: string;
    description?: string;
    image?: string;
    name?: string;
    subtitle?: string;
    extra?: string;
  }>;
  totalAvailable: number;
}

export enum EOMSStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface IBundlePurchaseMeta {
  pricing: number;
  saving: number;
  city: string;
  cityGroup: string;
}

export interface IBundlePurchaseStatus {
  isPurchased: boolean;
  purchaseStatus: EOMSStatus;
  currentDayPurchaseCount: number;
  couponCode: string | null;
  meta: IBundlePurchaseMeta;
}

export enum PaymentModeEnum {
  GATEWAY = 'GATEWAY',
  CARD = 'CARD',
  NETBANKING = 'NETBANKING',
  UPI = 'UPI',
  HEALTH_WALLET = 'HEALTH_WALLET',
}

export enum SupportedPaymentGatewayEnum {
  RAZORPAY = 'RAZORPAY',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
}

export enum PaymentStatusEnum {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface PaymentOption {
  paymentMode: PaymentModeEnum;
  applicable: boolean;
  isWalletActive: boolean;
  selected: boolean;
  payableAmount: IMoneyWithNativeStringWithoutDecimal;
  gatewayId: SupportedPaymentGatewayEnum;
  paymentModeSpecificDetails?: {
    healthWallet?: {
      currentBalance: IMoneyWithNativeStringWithoutDecimal;
      balanceToUse: IMoneyWithNativeStringWithoutDecimal;
      balanceLeft: IMoneyWithNativeStringWithoutDecimal;
      organisationBenefitId?: string;
      walletEligible?: boolean;
    };
  };
}

export interface SelectedPaymentMode {
  paymentMode: PaymentModeEnum;
  payableAmount: IMoneyWithNativeStringWithoutDecimal;
}

export interface PaymentDetails {
  paymentMode: PaymentModeEnum;
  paymentStatus: PaymentStatusEnum;
  gatewayId: string;
  paymentModeSpecificDetails: {
    gateway?: {
      orderId: string;
      apiKey?: string;
      amount: IMoneyWithNativeStringWithoutDecimal;
      redirectUrl: string;
    };
    healthWallet?: {
      transactionId: string;
    };
  };
}

export interface ICheckoutResponse {
  orderId: string;
  paymentDetails: PaymentDetails[];
  totalAmount: IMoneyWithNativeString;
  paymentStatus: PaymentStatusEnum;
}

export interface ICheckoutItem {
  benefitId: string;
  sku: string;
  quantity: number;
  pricingId: string;
}

export interface IOrderCustomer {
  customerId: string;
  source: 'MEMBER' | 'D2C';
  name: string;
}

export enum EOrderState {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
  REFUNDED = 'REFUNDED',
  FULFILLMENT_PENDING = 'FULFILLMENT_PENDING',
}

export enum EFulfillmentStatus {
  CREATED = 'CREATED',
  IN_PROCESS = 'IN_PROCESS',
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
}

export enum EFulfillmentStrategy {
  COUPON = 'COUPON',
  API = 'API',
  OFFLINE = 'OFFLINE',
}

export interface IFulfillmentDetails {
  customer: IOrderCustomer;
  startDate: string;
  status: EFulfillmentStatus;
  benefitId: string;
  orderItemId: string;
  orderId: string;
  fulfillmentStrategy: EFulfillmentStrategy;
}

export interface IOrderItem {
  benefitId: string;
  sku: string;
  name?: string;
  description?: string | null;
  quantity: number;
  totalAmount: IMoney;
  taxAmount?: IMoney;
  orderItemId?: string;
  discountAmount?: IMoney;
  stickerAmount?: IMoney;
  taxComponents?: Array<{
    key: string;
    amount: IMoney;
    rate?: number;
  }>;
  meta?: Record<string, string> | null;
  hsnCode?: string | null;
  pricingId: string;
  createdAt: Date;
  redirectionUrl: string;
  fulfillmentDetails?: IFulfillmentDetails;
}

export interface IOrder {
  customer: IOrderCustomer;
  idempotentKey: string;
  orderNumber: string;
  state: EOrderState;
  stickerAmount: IMoney;
  discountAmount: IMoney;
  taxAmount: IMoney;
  totalAmount: IMoney;
  items: Array<IOrderItem>;
}

export enum ERedemptionMethodType {
  COUPON_CODE = 'COUPON_CODE',
  WEB_URL = 'WEB_URL',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
}

export enum ERedemptionStatusType {
  UNAVAILABLE = 'UNAVAILABLE',
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  UNDELIVERED = 'UNDELIVERED',
  REDEEMED = 'REDEEMED',
}

export interface ISKURedemption {
  redeemedBy: {
    memberId: string;
    organisationId: string;
    membershipId?: string | null;
    organisationBenefitId?: string | null;
  };
  benefitId: string;
  typeOfRedemption?: ERedemptionMethodType;
  value?: string;
  status: ERedemptionStatusType;
  deliveredAt?: Date;
  redeemedAt?: Date;
}

export interface ISosResponse {
  isEnabled: boolean;
  title: string;
  cta: string;
  supportContactNumber: string;
  isDirectCallAvailable: boolean;
  isRequestCallbackAvailable: boolean;
  popupText: string;
  callbackETA: string;
}

export interface IHomepageQueryResponse {
  sos: ISosResponse;
}

// Retail Health Insurance Types

export enum PostPaymentStatus {
  Pending = 'pending',
  Confirming = 'confirming',
  Success = 'success',
  Failed = 'failed',
}

export type MemberDOB =
  | { year?: number; monthNumber?: number; date?: number }
  | string
  | undefined;

export type Member = {
  id?: string;
  name?: string;
  gender?: string;
  dateOfBirth?: MemberDOB;
};

export type PaymentPayload = {
  proposer?: Member;
  medicalQuestionnaireResponses?: Array<{ member?: Member }>;
};

export interface IMemberForm {
  id: string;
  name: string;
  gender: string;
  dateOfBirth: string;
  heightFt?: number;
  heightInches?: number;
  weightKg?: number;
  answers: IQuestionAnswer[];
  relation: string;
}

export interface ISelectedMember {
  age: number;
  relationship: EMemberRelationship;
  name?: string;
  id?: string;
  isAdded?: boolean;
  isChecked?: boolean;
}

export interface IGetQuotesRequest {
  sumInsured: number;
  leadId: string;
  includeEssentialRiders: boolean;
}

export interface IPurchaseIntentPayload {
  purchaseIntent: boolean;
}

export interface IHealthInsuranceMember {
  relationship: string;
  status: string;
  sumInsured: number;
  memberId: string;
  eid: string;
  gender: string;
  memberEid: string;
  doj: string;
  dob: string;
  createdAt: string;
  organisationId: string;
  organisationBenefitId: string;
  dateOfCommencement: {
    requested: string;
    final: string | null;
  };
  gradeId: string;
  name: string;
  firstName: string;
  lastName: string;
  retainOnExit: boolean;
  id: string;
}

export interface IHealthInsuranceDependent extends IHealthInsuranceMember {
  dependentId: string;
}

export interface IHealthInsuranceMemberAndDependents {
  member: IHealthInsuranceMember;
  dependents: IHealthInsuranceDependent[];
}

export type QuoteType = {
  planId: string;
  IsPlanRecommendedField: boolean;
  imageUrl: string;
  additionalRiders: Array<Record<string, string>>;
  premium: {
    centAmount: number;
    currency: string;
    currencyNativeString: string;
    currencyNativeStringWithoutDecimal: string;
  };
  title: string;
  availableAtExtracost: Array<{ title: string; imageUrl: string }>;
  features: Array<{ title: string; imageUrl: string }>;
  quoteId: string;
};

export interface IHealthInsuranceConfig {
  ageConstraints: {
    adult: {
      min: {
        value: number;
        unit: string;
      };
      max: {
        value: number;
        unit: string;
      };
    };
    child: {
      min: {
        value: number;
        unit: string;
      };
      max: {
        value: number;
        unit: string;
      };
    };
  };
  sumInsuredsAvailable: number[];
  availablePlans: IHealthInsurancePlan[];
}

export interface IHealthInsurancePlan {
  benefitId: string;
  kyc: string;
  requiredProposerFields?: string[];
  requiredNomineeFields?: string[];
  riders: IHealthInsuranceRider[];
}

export interface IHealthInsuranceRider {
  benefitId: string;
  createdAt: string;
  description: string;
  imageUrL: string;
  key: string;
  title: string;
  updatedAt: string;
  id: string;
}

export type MemberFormData = {
  self: {
    age: string;
    name?: string;
    isChecked: boolean;
  };
  spouse: {
    age: string;
    name?: string;
    isChecked: boolean;
  };
  children: {
    age: string;
    name?: string;
    isChecked: boolean;
    gender?: 'MALE' | 'FEMALE';
  }[];
  parents: {
    age: string;
    name?: string;
    isChecked: boolean;
  }[];
  pincode?: string;
  isParentIncluded?: boolean;
  isPincodeServicable?: boolean;
};


// Ledger Types
export enum ETransactionStatusValue {
  IN_PROCESS = "In Progress",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  APPROVED = "In Progress",
  SUCCESS = "Processed",
  REJECTED = "Rejected",
  DELETED = "Cancelled",
}

export interface ITransaction {
  transactionInitiatedAt: string;
  productTypeValue: string;
  statusValue: ETransactionStatusValue;
  referenceId: string;
  userName: string;
  potentialAmount: {
    currencyNativeString: string;
    centAmount: number;
  };
  actualAmount: {
    currencyNativeString: string;
    centAmount: number;
  };
}

export interface ILedgerApiResponse {
  data: ILedgerApiResponse | PromiseLike<ILedgerApiResponse>;
  transactions: ITransaction[];
  totalPages: number;
  totalCount: number;
}

export interface TLedgerFilter {
  transactionInitiatedAtFrom?: string | null;
  transactionInitiatedAtTo?: string | null;
  familyMembers?: Array<{
    id: string;
    relation: string;
  }>;
  status?: string[];
}

export interface IFilterOption {
  value: string;
  title: string;
  icon: string;
}

export interface IDateRangeOption {
  name: string;
  title: string;
}

export interface ILedgerFilterConfig {
  title: string;
  type: 'checkbox' | 'tile' | 'date-range';
  name: string;
  options?: IFilterOption[] | IDateRangeOption[];
}

export interface ILedgerMembership {
  name: string;
  relationship: string;
  relationshipDescription: string;
  icon: string;
  memberId?: string;
  dependentId?: string;
}
export interface ISelectedMember {
  age: number;
  relationship: EMemberRelationship;
}

export enum EMedicalQuestions {
  PRE_EXISTING_DISEASES = 'PRE_EXISTING_DISEASES',
  MEDICAL_HISTORY = 'MEDICAL_HISTORY',
  CLAIM_DETAILS = 'CLAIM_DETAILS',
  SUBSTANCE_USE = 'SUBSTANCE_USE',
}

export interface IMembersData {
  [relation: string]: {
    name: string;
    gender: string;
    dob: string;
    heightFeet: number;
    heightInches: number;
    weight: number;
    selectedQuery: string;
    selectedDiseases: Array<string>;
    finalDiseases: Array<string>;
    selectedMedicalHistory: Array<string>;
    finalSelectedMedicalHistory: Array<string>;
    selectedClaimDetails: Array<string>;
    finalSelectedClaimDetails: Array<string>;
    selectedSubstances: Record<string, string | null>;
    finalSelectedSubstances: Record<string, string>;
    otherDiseases: string;
    selectedOptions: Record<string, 'yes' | 'no'>;
    medicalDetails?: {
      PreExistingDiseasesOption?: string;
      preExistingDiseases?: Array<string>;
      medicalHistoryOption?: string;
      medicalHistory?: Array<string>;
      insuranceClaimsOption?: string;
      insuranceClaims?: Array<string>;
      substanceUseOption?: string;
      substanceUse?: Record<string, string>;
    };
  };
}


export type Status = 'eligible' | 'pending' | 'updated' | 'ineligible';

export interface EligibilityStatus {
  Self: Status;
  Spouse: Status;
  'Child 1': Status;
  'Child 2': Status;
  'Parent/in-law 1': Status;
  'Parent/in-law 2': Status;
}


export interface MedicalQuestion {
  id: EMedicalQuestions;
  title: string;
  description?: string;
  selectedOptionsDescription: string;
  count: number;
}


export interface SubstanceOption {
  title: string;
  description: string;
  options: string[];
}
export interface IVerificationStatus {
  isVerified: boolean;
  verificationProgress: number;
  isVerifying: boolean;
}

// Medical Questions API Response Types
export interface IValidationRules {
  type: 'radio' | 'checkbox' | 'number' | 'textarea' | 'text';
  required: boolean;
  allowOther?: boolean;
  errorMessage: string;
  maxSelections?: number;
  minSelections?: number;
  maxLength?: number;
  minLength?: number;
  max?: number;
  min?: number;
  step?: number;
  placeholder?: string;
  wordCount?: boolean;
  otherPlaceholder?: string;
  customValidation?: string;
  metadata?: {
    category?: string;
    riskFactor?: string;
    riskCalculation?: boolean;
  };
}

export interface IChoice {
  id: string;
  questionId: string;
  value: string;
  label: string;
  code: string;
  displayOrder: number;
  isActive: boolean;
  metadata: Record<string, unknown> | null;
  followupQuestions: IQuestion[];
  createdAt: string;
  updatedAt: string;
}

export interface IQuestion {
  id: string;
  title: string;
  description: string;
  type: 'SINGLE_CHOICE' | 'MULTI_SELECT' | 'MULTI_SELECT_CHECKBOX' | 'TEXT' | 'NUMBER';
  required: boolean;
  displayOrder: number;
  validationRules: IValidationRules;
  questionnaireId: string;
  createdAt: string;
  updatedAt: string;
  choices: IChoice[];
  mobileUI: {
    type: string;
  }
}

export interface IQuestionnaire {
  id: string;
  title: string;
  description: string;
  benefitId: string;
  isActive: boolean;
  metadata: {
    version: string;
    category: string;
  };
  createdAt: string;
  updatedAt: string;
  questions: IQuestion[];
}

export interface IInsuredMember {
  id: string;
  age: number;
  gender: 'MALE' | 'FEMALE';
  isPED: boolean;
}

export interface IMedicalQuestionsResponse {
  questionnaire: IQuestionnaire;
  insuredMembers: IInsuredMember[];
}

export interface IQuestionAnswer {
  questionId: string;
  answer: string | string[] | number;
  otherAnswer?: string;
}

export interface IValidationError {
  questionId: string;
  message: string;
  field?: string;
}

export interface IQuestionValidationResult {
  isValid: boolean;
  errors: IValidationError[];
}
export interface ISelectedMember {
  age: number;
  relationship: EMemberRelationship;
  existingAilments: string;
}

// Cart interfaces
export interface ICartItem {
  benefitId: string;
  sku: string;
  quantity: number;
  pricingId: string;
  createdAt: string;
  redirectionUrl: string;
  id: string;
  name?: string;
  totalAmount: IMoneyWithNativeString;
  totalAmountBeforeDiscountPreTax: IMoneyWithNativeStringWithoutDecimal;
  taxAmount: IMoneyWithNativeString;
  discountAmount: IMoneyWithNativeString;
  couponDiscountAmount?: IMoneyWithNativeString;
  stickerAmount: IMoneyWithNativeString;
  taxComponents: Array<{
    amount: IMoneyWithNativeString;
    key: string;
    rate: number;
  }>;
  walletEligible?: boolean;
  subLimitInfo?: {
    benefitId: string;
    amountSublimitFound: boolean;
    walletBalance: {
      balanceProvided: IMoneyWithNativeStringWithoutDecimal;
      balanceLeft: IMoneyWithNativeStringWithoutDecimal;
      balanceUsed: IMoneyWithNativeStringWithoutDecimal;
    };
  };
}

export interface ICouponRule {
  event: {
    type: string;
    params: Record<string, string | number | boolean>;
  };
  conditions: {
    all: Array<{
      fact: string;
      path: string;
      value: string | number | boolean;
      operator: string;
    }>;
  };
}

export interface ICouponDetails {
  code: string;
  discountType: EDiscountType;
  startDate: string;
  endDate: string;
  maxLimit: number | null;
  maxLimitPerUser: number | null;
  rules: ICouponRule[] | null;
  unlockable: boolean;
  status: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
  approvedBy: string | null;
  approvedAt: string | null;
  discoverable: boolean;
  description: Array<string> | null;
  subTitle: string | null;
  title: string;
  id: string;
  discountValueCentAmount: number;
  discountValueCurrency: string;
  locked: boolean;
  maxDiscountValueCentAmount?: number;
  maxDiscountValueCurrency?: string;
}

export interface ICart {
  totalAmount: IMoneyWithNativeString;
  taxAmount: IMoneyWithNativeString;
  totalAmountBeforeDiscountPreTax: IMoneyWithNativeStringWithoutDecimal;
  discountAmount: IMoneyWithNativeString;
  couponDiscountAmount?: IMoneyWithNativeString;
  stickerAmount: IMoneyWithNativeString;
  subLimitInfo?: {
    benefitId?: string;
    amountSublimitFound?: boolean;
    walletBalance: {
      balanceProvided: IMoneyWithNativeStringWithoutDecimal;
      balanceLeft: IMoneyWithNativeStringWithoutDecimal;
      balanceUsed: IMoneyWithNativeStringWithoutDecimal;
    };
  };
  items: Array<ICartItem>;
  customer: {
    customerId: string;
    source: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
  id: string;
  couponId?: string;
  couponDetails?: ICouponDetails;
}

export interface IGetCartResponse {
  cart: ICart | null;
  paymentOptions: PaymentOption[];
  message: string;
}

export interface IAddToCartResponse {
  cart: ICart;
  paymentOptions: PaymentOption[];
  message: string;
}

export interface IApplicableCoupon {
  code: string;
  discountType: EDiscountType;
  startDate: string;
  endDate: string;
  maxLimit: number | null;
  maxLimitPerUser: number | null;
  rules: ICouponRule[] | null;
  unlockable: boolean;
  status: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
  approvedBy: string | null;
  approvedAt: string | null;
  discoverable: boolean;
  description: Array<string> | null;
  subTitle: string | null;
  title: string;
  id: string;
  discountValueCentAmount: number;
  discountValueCurrency: string;
  locked: boolean;
  maxDiscountValueCentAmount?: number;
  maxDiscountValueCurrency?: string;
}

export interface IApplicableCouponsResponse {
  coupons: Array<IApplicableCoupon>;
  message: string;
}

export enum EAppliedMethod {
  CARD = 'CARD',
  CODE = 'CODE',
}
